import React, { Component } from "react";
import Cookies from "universal-cookie";
import { Buffer } from "buffer";
import MainLayout from "../../components/layouts/MainLayout";
import { withRouter } from "../../hoc/withRouter";
import withAuth from "../../hoc/withAuth";
import { Button, Col, DatePicker, Form, Modal, Row, Select, Table, Upload } from "antd";
import { TaxInTransferStates } from "./types/TaxInTransferTypes";
import { SaveOutlined, UploadOutlined } from "@ant-design/icons";
import { taxOtodisService } from "../../services/otodisApi/TaxOtodisService";
import moment from "moment";

export interface TaxInTransferProps {}

class TaxInTransfer extends Component<TaxInTransferProps & any, TaxInTransferStates> {
  private readonly initState!: TaxInTransferStates;
  private token = new Cookies().get("_t");
  private user = JSON.parse(Buffer.from(new Cookies().get("_u"), "base64").toString());
  private tableColumns = [
    {
      title: "Data Excel",
      dataIndex: "stock",
      key: "stock",
    },
    {
      title: "Keterangan",
      dataIndex: "desc",
      key: "desc",
      render: (text: string, record: any) => {
        if (record.status === "failed") {
          return <span style={{ color: "red" }}>{text}</span>;
        }
        return text;
      },
    },
  ];

  constructor(props: (TaxInTransferProps & any) | any) {
    super(props);

    this.initState = {
      submitting: false,
      showUploadList: false,
      dealerCode: props.match.params.dealerCode.replace(/-/g, "#"),
      orderMonth: moment().clone().format("YYYY-MM"),
      supplier: "",
      dataType: "",
      fileExcel: [],
      dataTable: [],
      total_data: -1,
      total_failed: -1,
      total_success: -1,
    };
    this.state = { ...this.initState };
  }

  onDealerChange = async (data: any) => {
    this.setState({
      dealerCode: data.value,
    });
  };

  beforeUploadFile = (file: any) => {
    this.setState({
      showUploadList: true,
    });

    this.setState({
      fileExcel: file,
    });
    return false;
  };

  submitData = async () => {
    if (!this.state.supplier || !this.state.orderMonth || !this.state.dataType) {
      Modal.error({
        title: "Proses Gagal",
        content: "Lengkapi Data",
      });
      return;
    }

    this.setState({
      submitting: true,
    });

    const formData = new FormData();
    formData.append("month", moment(this.state.orderMonth).endOf("month").format("YYYY-MM") + "-01");
    formData.append("input_type", this.state.dataType);
    formData.append("updated_by", this.user);
    formData.append("document_file", this.state.fileExcel);

    try {
      taxOtodisService.setToken(this.token);
      await taxOtodisService.TransferMultiTaxIn(formData, this.state.supplier).then((result) => {
        const { total_data, total_failed, total_success, data_failed, data_success } = result.data;
        const dataResponseTable: { stock: string; desc: string; status: string }[] = [];

        // Pemrosesan data_failed
        Object.entries(data_failed).forEach(([order, errorMessages]: [string, any]) => {
          errorMessages.forEach((errorMessage: string) => {
            dataResponseTable.push({ stock: order, desc: errorMessage, status: "failed" });
          });
        });

        // Pemrosesan data_success
        data_success.forEach((item: any) => {
          const { engine_number } = item;
          dataResponseTable.push({ stock: engine_number, desc: "SUCCESS", status: "success" });
        });

        this.setState({
          submitting: false,
          total_data: total_data,
          total_failed: total_failed,
          total_success: total_success,
          dataTable: dataResponseTable,
        });

        Modal.success({
          title: "Proses Sukses",
          content: "Lihat Table untuk Detail Proses data",
        });
      });
    } catch (e: any) {
      this.setState({
        submitting: false,
      });
      Modal.error({
        title: "Proses Gagal",
        content: "Server Menolak Inputan Anda :" + e,
      });
    }
  };

  downloadSampleFile = () => {
    if (this.state.supplier) {
      const sampleFileUrl = "https://asia-southeast2-autotrimitra.cloudfunctions.net/otodis__taxActivityGCF/tax-in/sample-file?type=" + this.state.supplier;
      window.open(sampleFileUrl, "_blank");
    }
  };

  onFieldChange = <T extends keyof Pick<any, "supplier" | "dataType">>(target: T, value: any) => {
    const currentState: any = { ...this.state };
    switch (target) {
      case "supplier":
        currentState.supplier = value;
        break;
      case "dataType":
        currentState.dataType = value;
        break;
    }
    this.setState({
      ...currentState,
    });
  };

  onchangeOrderMonth = (data: any) => {
    if (data) {
      this.setState({
        orderMonth: data,
      });
    }
  };

  render() {
    return (
      <React.Fragment>
        <MainLayout onChangeDealer={this.onDealerChange} breadcrumbPath={`Tax In`} breadcrumbMenu={`Transfer Tax In`} defaultSelectedKeys={["m-tax-in-transfer-data"]} defaultOpenKeys={["sm-tax-in"]}>
          <Form layout="vertical">
            <Row>
              <Col xl={{ span: 4 }} lg={{ span: 4 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ padding: 5 }}>
                <Form.Item>
                  <span className={`text-small-grey-nopadding`}>Bulan Stock</span>
                  <DatePicker picker="month" value={moment(this.state.orderMonth, "YYYY-MM")} onChange={(event) => this.onchangeOrderMonth(event)} format={"YYYY-MM"} style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col xl={{ span: 6 }} lg={{ span: 6 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ padding: 5 }}>
                <Form.Item>
                  <span className={`text-small-grey-nopadding`}>Supplier</span>
                  <Select placeholder="Supplier" showSearch optionFilterProp="children" onChange={(value) => this.onFieldChange("supplier", value)} value={this.state.supplier}>
                    <Select.Option key={`motora`} value={`motora`}>{`Daya Motora`}</Select.Option>
                    <Select.Option key={`wisesa`} value={`wisesa`}>{`Daya Wisesa`}</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              {/* </Row>
            <Row> */}
              <Col xl={{ span: 6 }} lg={{ span: 6 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ padding: 5 }}>
                <Form.Item>
                  <span className={`text-small-grey-nopadding`}>Tipe Data</span>
                  <Select placeholder="Tipe Data" showSearch optionFilterProp="children" onChange={(value) => this.onFieldChange("dataType", value)} value={this.state.dataType}>
                    <Select.Option key={`UNIT`} value={`UNIT`}>{`UNIT`}</Select.Option>
                    <Select.Option key={`PART`} value={`PART`}>{`PART`}</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col style={{ padding: 5 }}>
                <Form.Item>
                  <Upload maxCount={1} listType="picture" beforeUpload={this.beforeUploadFile} showUploadList={this.state.showUploadList}>
                    <Button icon={<UploadOutlined />} style={{ width: "100%" }}>
                      Upload File Tax IN
                    </Button>
                  </Upload>
                </Form.Item>
              </Col>
              <Col style={{ padding: 5 }}>
                <Button type="primary" loading={this.state.submitting} onClick={(event) => this.submitData()} icon={<SaveOutlined />}>
                  Transfer Tax In
                </Button>
              </Col>
              <Col style={{ padding: 5 }}>
                <Button type="primary" onClick={(event) => this.downloadSampleFile()} icon={<SaveOutlined />}>
                  Get Sample File
                </Button>
              </Col>
            </Row>
            <Row>
              <Col xl={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 5 }}>
                <Table dataSource={this.state.dataTable} columns={this.tableColumns} pagination={false} bordered className="table-mycustom" />
              </Col>
            </Row>
          </Form>
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(withRouter(TaxInTransfer), 36);
